import { useEffect, useState } from 'react';
import { useOrganization } from '../context/OrganizationContext';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { getAuth } from 'firebase/auth';

export default function useAdsEntitlement() {
  const { context, loading: contextLoading } = useOrganization();
  const [state, setState] = useState({ loading: true, hasAds: false });

  useEffect(() => {
    if (contextLoading) return;

    const auth = getAuth();
    const uid = auth.currentUser?.uid;
    if (!uid) {
      setState({ loading: false, hasAds: false });
      return;
    }

    const docPath = context.isOrganization
      ? `organizations/${context.orgId}`
      : `clientes/${uid}`;

    const ref = doc(db, docPath);
    const unsub = onSnapshot(ref, (snap) => {
      const data = snap.data() || {};
      let addons = data.addonsActivos || {};
      if (Array.isArray(addons)) {
        addons = Object.fromEntries(addons.map(a => [a, 1]));
      }
      setState({
        loading: false,
        hasAds: (addons.addon_ads_studio || 0) > 0
      });
    }, (error) => {
      console.error('useAdsEntitlement error:', error);
      setState({ loading: false, hasAds: false });
    });

    return () => unsub();
  }, [contextLoading, context.isOrganization, context.orgId]);

  return state;
}
